// This file is autogenerated. Any changes will be overwritten.

export const set = 'streamline';

export const name = 'reset';

export const Component = () => (
  <g fill='none' stroke='currentColor' strokeLinecap='round' strokeLinejoin='round'>
    <path d='M7.875 16.313A7.312 7.312 0 1 1 15.188 9v.563' />
    <path d='m17.438 7.31-2.25 2.25-2.25-2.25' />
  </g>
);

export const viewBox = '0 0 18 18';
